import styled from 'styled-components';
import { Title, Subtitle } from '../../components/titles';
import { FontSize16, FontFamilyRegular, FontSize10, FontSize14 } from '../../components/fonts';
import { MarginTop10, MarginTop8 } from '../../components/margins';
import { InputGradient } from '../../components/Buttons';
import { BaseText, TextBlock } from '../../components/text';

export const GrayDiv = styled.div`
    width: 100%;
    background-color: rgba(0, 0, 0, 0.02);
    padding: 20px;
    ${MarginTop10};
    position: relative;
`;

export const SectionTitle = styled(Title)`
    ${FontSize16};
`;

export const SectionTitleTopMargin = styled(Title)`
    ${FontSize16};
    margin-top: 40px;
`;

export const SectionSubtitle = styled(Subtitle)`
    font-size: 15px;
    ${MarginTop10};
`;

export const InputBooleanWrapper = styled.div`
    ${MarginTop10};
`;

export const MarketingTitle = styled.h3`
    margin: 0;
    padding: 0;
    ${FontFamilyRegular};
    ${FontSize10};
    text-decoration: underline;
    font-weight: normal;
`;

export const InputsBooleanWrapperMarketing = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const InputBooleanWrapperMarketing = styled.div`
    margin-top: 5px;
`;

export const InputBooleanWrapperMarketingRightMargin = styled(InputBooleanWrapperMarketing)`
    margin-right: 36px;
`;

export const MarketingContainer = styled.div`
    margin-top: 24px;
`;

export const AccordionContainer = styled.div`
    margin-top: 60px;
    width: 100%;
`;

export const InfoIconContainer = styled.div`
    position: absolute;
    top: 14px;
    right: 16px;
`;

export const TextConditions = styled(TextBlock)`
    ${BaseText};
    ${FontSize14};
    line-height: 24px;
    width: 100%;
    ${MarginTop8};
`;

export const ReadMore = styled.span`
    ${BaseText};
    ${FontSize14};
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`;